/**
 * Wizard venue select / session stash / waitlist (from flow.attach).
 * Resets live cursors via S.resetLiveCursors — do not copy lastLive* primitives.
 */
(function (global) {
  'use strict';
  if (global.WorkshopBookingWizardFlowVenue) return;
  global.WorkshopBookingWizardFlowVenue = {
    attach: function (S) {
      if (!S) return;
      var bookingRoot = S.bookingRoot;
      var eventsRoot = S.eventsRoot;
      var isStoreVenue = S.isStoreVenue;
      var resolveVenueDisplayLabel = S.resolveVenueDisplayLabel;
      var setBranch = S.setBranch;
      var slotDateKey = S.slotDateKey;
      var slotVisible = S.slotVisible;
      var state = S.state;
      var stepEl = S.stepEl;
      var syncVenueKindAttr = S.syncVenueKindAttr;
      var updateBranchTitles = S.updateBranchTitles;
      var updateProductVenueSeoCopy = S.updateProductVenueSeoCopy;
      var updateProgressLabels = S.updateProgressLabels;
      var updateWizardBookingUrl = S.updateWizardBookingUrl;
      var urlHasWizardDeepLink = S.urlHasWizardDeepLink;
      var venueIsWaitlistOnly = S.venueIsWaitlistOnly;
      var venueLabelForWizard = S.venueLabelForWizard;
      var wizardRoot = S.wizardRoot;

      function applyDatetimeSelectionAfterSlots(opts) {
        if (typeof S.applyDatetimeSelectionAfterSlots === 'function') S.applyDatetimeSelectionAfterSlots(opts);
      }
      function slotsForDate(key) {
        return typeof S.slotsForDate === 'function' ? S.slotsForDate(key) : [];
      }
      function slotSyncKey(slot) {
        return typeof S.slotSyncKey === 'function' ? S.slotSyncKey(slot) : '';
      }
      function resetDatetimeControlsDom() {
        if (typeof S.resetDatetimeControlsDom === 'function') S.resetDatetimeControlsDom();
      }
      function prefetchVenueCalendar(venue) {
        if (typeof S.prefetchVenueCalendar === 'function') S.prefetchVenueCalendar(venue);
      }
      function startDatetimeStep() {
        return typeof S.startDatetimeStep === 'function' ? S.startDatetimeStep() : Promise.resolve();
      }
      function startPopupBookingStep() {
        return typeof S.startPopupBookingStep === 'function' ? S.startPopupBookingStep() : Promise.resolve();
      }
      function setDatetimeCalLoading(on, msg) {
        if (typeof S.setDatetimeCalLoading === 'function') S.setDatetimeCalLoading(on, msg);
      }
      function setPopupDatetimeLoading(on) {
        if (typeof S.setPopupDatetimeLoading === 'function') S.setPopupDatetimeLoading(on);
      }
      function setPopupDatetimeHint(msg, isError) {
        if (typeof S.setPopupDatetimeHint === 'function') S.setPopupDatetimeHint(msg, isError);
      }
      function syncAtcReminder() {
        if (typeof S.syncAtcReminder === 'function') S.syncAtcReminder();
      }
      function syncSiblingWorkshopPromo() {
        if (typeof S.syncSiblingWorkshopPromo === 'function') S.syncSiblingWorkshopPromo();
      }
      function resetLiveCursors() {
        if (typeof S.resetLiveCursors === 'function') S.resetLiveCursors();
      }

    function findVenueCardByRef(refId) {
      var want = String(refId || '').trim();
      if (!want || !eventsRoot) return null;
      var cards = eventsRoot.querySelectorAll('.wb-venue-pick-card, .wb-venue-card');
      for (var i = 0; i < cards.length; i++) {
        var c = cards[i];
        var cref = String((c && c.getAttribute && c.getAttribute('data-venue-ref-id')) || '').trim();
        if (cref && cref === want) return c;
        if (c && c._wbVenue && String(c._wbVenue.venue_ref_id || '').trim() === want) return c;
      }
      return null;
    }

    function rebindSelectedVenueCard() {
      if (!state.selectedVenue) return null;
      var card = state.selectedVenueCard;
      if (card && eventsRoot && eventsRoot.contains(card) && card._wbVenue) return card;
      var ref = String(state.selectedVenue.venue_ref_id || '').trim();
      var next = findVenueCardByRef(ref);
      if (!next || !next._wbVenue) return null;
      var prev = state.selectedVenue;
      state.selectedVenueCard = next;
      state.selectedVenue = next._wbVenue;
      if (prev && prev !== state.selectedVenue) {
        if (Array.isArray(prev.events) && prev.events.length) {
          if (!Array.isArray(state.selectedVenue.events) || !state.selectedVenue.events.length) {
            state.selectedVenue.events = prev.events;
          }
        }
        if (prev._wbLoadedMonths) {
          if (!state.selectedVenue._wbLoadedMonths) {
            state.selectedVenue._wbLoadedMonths = Object.create(null);
          }
          Object.keys(prev._wbLoadedMonths).forEach(function (ym) {
            state.selectedVenue._wbLoadedMonths[ym] = true;
          });
        }
      }
      if (state.selectedVenue.has_events !== true && state.flow !== 'waitlist') {
        state.flow = venueIsWaitlistOnly(state.selectedVenue, next) ? 'waitlist' : 'booking';
        wizardRoot.setAttribute('data-wbw-flow', state.flow);
      }
      next.classList.add('wbw-venue-selected');
      next.setAttribute('aria-pressed', 'true');
      return next;
    }

    function updateVenueContinue() {
      var btn = wizardRoot.querySelector('[data-wbw-action="to-next"]');
      if (!btn) return;
      rebindSelectedVenueCard();
      var valid =
        !!state.selectedVenue &&
        state.flow !== 'waitlist' &&
        state.selectedVenue.has_events === true &&
        !!String(state.selectedVenue.venue_ref_id || '').trim();
      btn.disabled = !valid;
      syncAtcReminder();
    }

    function syncVenueFlipState() {
      if (!eventsRoot) return;
      eventsRoot.querySelectorAll('.wbw-venue-flip-card').forEach(function (c) {
        c.classList.remove('wbw-venue-flipped');
      });
      var card = state.selectedVenueCard;
      if (
        card &&
        card.classList &&
        card.classList.contains('wbw-venue-flip-card') &&
        card.classList.contains('wbw-venue-selected') &&
        state.flow === 'waitlist'
      ) {
        card.classList.add('wbw-venue-flipped');
      }
    }

    function closeWizardWaitlistModal() {
      var modal = wizardRoot.querySelector('[data-wbw-wl-modal]');
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('hidden', '');
      modal.setAttribute('aria-hidden', 'true');
    }

    function openWizardWaitlistModalFromDetail(detail) {
      detail = detail || {};
      var venue = state.selectedVenue || {};
      if (detail.venueRefId || detail.venueName) {
        venue = {
          venue_ref_id: detail.venueRefId || venue.venue_ref_id || '',
          venue_name: detail.venueName || venue.venue_name || venue.name || '',
          city_key: venue.city_key || '',
        };
        if (detail.customerLocation) {
          var locParts = String(detail.customerLocation).split(',');
          if (locParts[0]) venue.city_name = String(locParts[0]).trim();
        }
      }
      if (!String(venue.venue_ref_id || '').trim() && !String(venue.venue_name || venue.name || '').trim()) return;

      /* Prefer Connect when available; forceNative skips Connect (boot timeout fallback). */
      var host = bookingRoot || detail.bookingRoot || null;
      if (!detail.forceNative) {
        if (typeof window.wbOpenAogenWaitlistPopup === 'function' && window.wbOpenAogenWaitlistPopup(venue, host)) {
          closeWizardWaitlistModal();
          return;
        }
        if (
          typeof window.wbFindWaitlistAogenBlock === 'function' &&
          window.wbFindWaitlistAogenBlock() &&
          typeof window.wbBuildAogenBookingContext === 'function' &&
          typeof window.wbDispatchAogenBookingContext === 'function' &&
          typeof window.wbAogenFormsBlockReady === 'function' &&
          window.wbAogenFormsBlockReady(window.wbFindWaitlistAogenBlock())
        ) {
          if (typeof window.wbCloseNativeWaitlistModal === 'function') window.wbCloseNativeWaitlistModal();
          window.wbDispatchAogenBookingContext(
            window.wbBuildAogenBookingContext(venue, host, { intent: 'popup' })
          );
          closeWizardWaitlistModal();
          return;
        }
      }

      var modal = wizardRoot.querySelector('[data-wbw-wl-modal]');
      if (!modal) return;
      var vn = venueLabelForWizard();
      var title = modal.querySelector('[data-wbw-wl-modal-title]');
      if (title) {
        title.textContent = vn
          ? 'No workshops scheduled for ' + vn + ' yet'
          : 'No workshops scheduled yet';
      }
      var err = modal.querySelector('[data-wbw-wl-modal-error]');
      var ok = modal.querySelector('[data-wbw-wl-modal-success]');
      if (err) {
        err.hidden = true;
        err.textContent = '';
      }
      if (ok) ok.hidden = true;
      ['[data-wbw-wl-modal-name]', '[data-wbw-wl-modal-email]', '[data-wbw-wl-modal-notes]'].forEach(function (sel) {
        var el = modal.querySelector(sel);
        if (el) el.value = '';
      });
      modal.removeAttribute('hidden');
      modal.setAttribute('aria-hidden', 'false');
      modal.classList.add('is-open');
      var nameIn = modal.querySelector('[data-wbw-wl-modal-name]');
      try {
        if (nameIn) nameIn.focus();
      } catch (_) {}
    }

    function openWizardWaitlistModal() {
      openWizardWaitlistModalFromDetail({});
    }

    function wbwReadVenueCatalogRows() {
      if (!bookingRoot) return [];
      var el = bookingRoot.querySelector('script[type="application/json"][data-wb-venues-waitlist-catalog]');
      if (!el || !el.textContent) return [];
      try {
        var parsed = JSON.parse(el.textContent);
        return Array.isArray(parsed) ? parsed : [];
      } catch (_) {
        return [];
      }
    }

    function wbwVenueMatchesCatalogRow(venue, row) {
      if (!venue || !row) return false;
      var rowRef = String(row.venue_ref_id || '').trim();
      var venueRef = String(venue.venue_ref_id || venue.id || '').trim();
      if (rowRef && venueRef) {
        if (rowRef === venueRef) return true;
        var rowNum = rowRef.match(/(\d+)$/);
        var venueNum = venueRef.match(/(\d+)$/);
        if (rowNum && venueNum && rowNum[1] === venueNum[1]) return true;
      }
      var handle = String(row.venue_handle || '').trim().toLowerCase();
      var vHandle = String(venue.venue_handle || venue.handle || '').trim().toLowerCase();
      if (handle && vHandle && handle === vHandle) return true;
      var name = String(row.venue_name || '').trim().toLowerCase();
      var vName = String(venue.venue_name || venue.name || '').trim().toLowerCase();
      return !!(name && vName && (name === vName || name.indexOf(vName) >= 0 || vName.indexOf(name) >= 0));
    }

    function wbwMergeFacilityLabel(out, seen, item) {
      var t = '';
      if (item == null) return;
      if (typeof item === 'string' || typeof item === 'number') t = String(item).trim();
      else if (typeof item === 'object') {
        t = String(item.label || item.name || item.title || item.value || '').trim();
      } else t = String(item).trim();
      if (!t) return;
      var k = t.toLowerCase();
      if (seen[k]) return;
      seen[k] = true;
      out.push(t);
    }

    function wbwEnrichVenueFacilitiesFromCatalog(venue) {
      if (!venue) return venue;
      var hasOptions =
        (Array.isArray(venue.facility_options) && venue.facility_options.length) ||
        (Array.isArray(venue.facilities) && venue.facilities.length);
      var hasFlags =
        venue.wheelchair_accessible === true ||
        venue.accessible_toilets === true ||
        venue.ground_level === true ||
        venue.accessible_parking === true ||
        venue.accessible_parking_spot === true ||
        venue.lift_to_all_floors === true;
      if (hasOptions && hasFlags) return venue;

      var rows = wbwReadVenueCatalogRows();
      for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        if (!wbwVenueMatchesCatalogRow(venue, row)) continue;
        if (!hasOptions) {
          var merged = [];
          var seen = Object.create(null);
          var raw =
            Array.isArray(row.facility_options) && row.facility_options.length
              ? row.facility_options
              : Array.isArray(row.facilities)
                ? row.facilities
                : [];
          for (var j = 0; j < raw.length; j++) wbwMergeFacilityLabel(merged, seen, raw[j]);
          if (merged.length) {
            venue.facility_options = merged;
            venue.facilities = merged.slice();
            hasOptions = true;
          }
        }
        if (row.wheelchair_accessible === true) venue.wheelchair_accessible = true;
        if (row.accessible_toilets === true) venue.accessible_toilets = true;
        if (row.ground_level === true) venue.ground_level = true;
        if (row.accessible_parking === true || row.accessible_parking_spot === true) {
          venue.accessible_parking = true;
        }
        if (row.lift_to_all_floors === true) venue.lift_to_all_floors = true;
        break;
      }
      return venue;
    }

    function wbwEmitVenueMapSelection(venue) {
      if (!venue || typeof venue !== 'object') return;
      venue = wbwEnrichVenueFacilitiesFromCatalog(venue);
      var lat = venue.venue_lat != null ? venue.venue_lat : venue.lat != null ? venue.lat : venue.latitude;
      var lng = venue.venue_lng != null ? venue.venue_lng : venue.lng != null ? venue.lng : venue.longitude;
      lat = lat != null && lat !== '' ? Number(lat) : NaN;
      lng = lng != null && lng !== '' ? Number(lng) : NaN;
      var city = String(venue.city || venue.city_name || '').trim();
      var state = String(venue.state || venue.state_code || venue.region_code || '').trim();
      var detail = {
        title: String(venue.venue_name || venue.name || city || '').trim(),
        address: String(venue.venue_address || venue.address || '').trim(),
        city: city,
        state: state,
        region_code: state,
        state_code: state,
        lat: Number.isFinite(lat) ? lat : null,
        lng: Number.isFinite(lng) ? lng : null,
        location_id: String(venue.location_id || '').trim(),
        facilities: (function () {
          var raw = Array.isArray(venue.facilities) && venue.facilities.length
            ? venue.facilities
            : Array.isArray(venue.facility_options)
              ? venue.facility_options
              : [];
          var out = [];
          var seen = Object.create(null);
          for (var i = 0; i < raw.length; i++) {
            var item = raw[i];
            var t = '';
            if (item == null) t = '';
            else if (typeof item === 'string' || typeof item === 'number') t = String(item).trim();
            else if (typeof item === 'object') {
              t = String(item.label || item.name || item.title || item.value || '').trim();
            } else {
              t = String(item).trim();
            }
            if (!t) continue;
            var k = t.toLowerCase();
            if (seen[k]) continue;
            seen[k] = true;
            out.push(t);
          }
          return out;
        })(),
        facility_options: (function () {
          var raw = Array.isArray(venue.facility_options) && venue.facility_options.length
            ? venue.facility_options
            : Array.isArray(venue.facilities)
              ? venue.facilities
              : [];
          var out = [];
          var seen = Object.create(null);
          for (var i = 0; i < raw.length; i++) {
            var item = raw[i];
            var t = '';
            if (item == null) t = '';
            else if (typeof item === 'string' || typeof item === 'number') t = String(item).trim();
            else if (typeof item === 'object') {
              t = String(item.label || item.name || item.title || item.value || '').trim();
            } else {
              t = String(item).trim();
            }
            if (!t) continue;
            var k = t.toLowerCase();
            if (seen[k]) continue;
            seen[k] = true;
            out.push(t);
          }
          return out;
        })(),
        wheelchair_accessible: venue.wheelchair_accessible === true,
        accessible_toilets: venue.accessible_toilets === true,
        ground_level: venue.ground_level === true,
        accessible_parking: venue.accessible_parking === true || venue.accessible_parking_spot === true,
        lift_to_all_floors: venue.lift_to_all_floors === true,
      };
      if (!detail.title && !detail.address && !detail.city && detail.lat == null) return;
      try {
        document.dispatchEvent(new CustomEvent('wbw:venue-selected', { detail: detail }));
      } catch (_) {}
    }

    function venueSessionKey(venue) {
      return venue ? String(venue.venue_ref_id || '').trim() : '';
    }

    function clonePlainMap(obj) {
      var out = {};
      if (!obj) return out;
      Object.keys(obj).forEach(function (k) {
        var v = obj[k];
        if (v && typeof v === 'object') {
          out[k] = {
            dateKey: v.dateKey || '',
            gid: v.gid || '',
          };
        } else {
          out[k] = v;
        }
      });
      return out;
    }

    function peekVenueSession(venue) {
      var key = venueSessionKey(venue);
      return key && state.sessionByVenue ? state.sessionByVenue[key] || null : null;
    }

    function stashVenueSession(venue) {
      var key = venueSessionKey(venue);
      if (!key) return;
      if (!state.sessionByVenue) state.sessionByVenue = {};
      var slot = state.selectedSlot;
      state.sessionByVenue[key] = {
        selectedDate: String(state.selectedDate || ''),
        slotGid: slot && slot.gid ? String(slot.gid) : '',
        slotSyncKey: slot ? String(slotSyncKey(slot) || '') : '',
        variantQty: clonePlainMap(state.variantQty),
        variantWhen: clonePlainMap(state.variantWhen),
        focusedVariantId: String(state.focusedVariantId || ''),
        lockedVariantId: String(state.lockedVariantId || ''),
        userPickedCalDate: !!state._wbwUserPickedCalDate,
        viewMonth:
          state.viewMonth instanceof Date ? state.viewMonth.getTime() : 0,
      };
    }

    function applySavedVenueSession(saved) {
      if (!saved || !(saved.selectedDate || saved.slotGid || saved.slotSyncKey)) {
        applyDatetimeSelectionAfterSlots({
          priorDate: '',
          priorGid: '',
          deepLinkSlot: null,
          allowDeepLink: false,
          syncViewMonth: false,
        });
        return;
      }
      applyDatetimeSelectionAfterSlots({
        priorDate: saved.selectedDate || '',
        priorGid: saved.slotGid || '',
        deepLinkSlot: null,
        allowDeepLink: false,
        syncViewMonth: !!saved.selectedDate,
      });
      if (!state.selectedSlot && saved.slotSyncKey) {
        var list = saved.selectedDate ? slotsForDate(saved.selectedDate) : state.slotList || [];
        for (var i = 0; i < list.length; i++) {
          if (slotSyncKey(list[i]) === saved.slotSyncKey && slotVisible(list[i])) {
            state.selectedSlot = list[i];
            if (!state.selectedDate) state.selectedDate = slotDateKey(list[i]) || saved.selectedDate;
            break;
          }
        }
      }
    }

    function clearVenueSelection(options) {
      options = options || {};
      state.selectedVenueCard = null;
      state.selectedVenue = null;
      state.flow = 'booking';
      state.slotList = [];
      state.selectedDate = '';
      state.selectedSlot = null;
      state.variantWhen = {};
      state.lbEditVariant = '';
      state.lbApplyAll = null;
      state.lbAskApply = false;
      // Reset live cursors so a new venue never inherits the previous venue's
      // since watermark (would cause unchanged no-ops) or batch ordering.
      state._wbLiveSince = '';
      resetLiveCursors();
      if (!options.preserveVenueLabel) state.venueDisplayLabel = '';
      state._wbwForceCalRerender = true;
      try {
        window.__WORKSHOP_SELECTION__ = null;
      } catch (_) {}
      resetDatetimeControlsDom();
      wizardRoot.setAttribute('data-wbw-flow', 'booking');
      if (bookingRoot) bookingRoot.__wbWizardVenueChosen = false;
      if (!options.preserveUrl) {
        wizardRoot.__wbwUrlDeepLinkComplete = true;
        wizardRoot.__wbwUserReachedDatetime = false;
      }
      wizardRoot.querySelectorAll('.wb-venue-pick-card, .wb-venue-card').forEach(function (c) {
        c.classList.remove('wbw-venue-selected', 'wbw-venue-flipped');
        c.setAttribute('aria-pressed', 'false');
      });
      closeWizardWaitlistModal();
      if (!options.preserveUrl) {
        var urlPatch = { venue: '', eventId: '' };
        if (state.lockedVariantId) urlPatch.variantId = state.lockedVariantId;
        updateWizardBookingUrl(urlPatch);
      }
      updateVenueContinue();
      updateProgressLabels();
      updateBranchTitles();
      syncVenueKindAttr();
      syncSiblingWorkshopPromo();
      updateProductVenueSeoCopy();
      if (!options.preserveVenueLabel && !options.skipEmitVenueReset) {
        try {
          document.dispatchEvent(
            new CustomEvent('wbw:venue-reset', {
              detail: {
                bookingRoot: bookingRoot || null,
                fromClearVenueSelection: true,
              },
            })
          );
        } catch (_) {}
      }
    }

    function onVenueResetEvent(e) {
      var detail = (e && e.detail) || {};
      if (detail.fromClearVenueSelection) return;
      if (detail.bookingRoot && bookingRoot && detail.bookingRoot !== bookingRoot) return;
      /* Inventory search recenter / filter re-render must not re-arm URL auto-advance. */
      if (bookingRoot && bookingRoot.__wbWizardInventoryFilterActive) {
        if (state.branch === 'datetime' || state.branch === 'variants') return;
        clearVenueSelection({ preserveUrl: true, preserveVenueLabel: true });
        return;
      }
      /* Places / geocode search: never re-arm URL deep-link (would jump back to ?venue=). */
      var locSource =
        (typeof window !== 'undefined' &&
          window.__WORKSHOP_LOCATION__ &&
          window.__WORKSHOP_LOCATION__.source) ||
        '';
      if (
        locSource === 'places' ||
        locSource === 'places_autocomplete' ||
        locSource === 'geocode_search'
      ) {
        wizardRoot.__wbwUrlDeepLinkComplete = true;
        if (state.branch === 'datetime' || state.branch === 'variants') return;
        clearVenueSelection();
        return;
      }
      if (urlHasWizardDeepLink() && !wizardRoot.__wbwUserReachedDatetime) {
        wizardRoot.__wbwUrlDeepLinkComplete = false;
        if (state.branch === 'waitlist') {
          state.flow = 'booking';
          wizardRoot.setAttribute('data-wbw-flow', 'booking');
          setBranch('venue');
        }
        clearVenueSelection({ preserveUrl: true, preserveVenueLabel: true });
        return;
      }
      clearVenueSelection();
    }

    function selectVenueCard(card, options) {
      if (!card) return;
      var venue = card._wbVenue;
      if (!venue) return;
      var prevRef = state.selectedVenue
        ? String(state.selectedVenue.venue_ref_id || '').trim()
        : '';
      var nextRef = String(venue.venue_ref_id || '').trim();
      if (prevRef && nextRef && prevRef !== nextRef) {
        stashVenueSession(state.selectedVenue);
        state.slotList = [];
        state.daysWithEvents = {};
        state.selectedDate = '';
        state.selectedSlot = null;
        state.variantWhen = {};
        state.variantQty = {};
        state.focusedVariantId = '';
        state.lockedVariantId = '';
        state.lbEditVariant = '';
        state.lbApplyAll = null;
        state.lbAskApply = false;
        state.viewMonth = new Date();
        state._wbwUserPickedCalDate = false;
        state._wbLiveSince = '';
        resetLiveCursors();
        state._wbwForceCalRerender = true;
        state._wbCalLoadSeq = (state._wbCalLoadSeq || 0) + 1;
        try {
          window.__WORKSHOP_SELECTION__ = null;
        } catch (_) {}
        resetDatetimeControlsDom();
        updateWizardBookingUrl({ eventId: '' });
      }

      wizardRoot.querySelectorAll('.wb-venue-pick-card, .wb-venue-card').forEach(function (c) {
        c.classList.remove('wbw-venue-selected', 'wbw-venue-flipped');
        c.setAttribute('aria-pressed', 'false');
      });
      card.classList.add('wbw-venue-selected');
      card.setAttribute('aria-pressed', 'true');
      state.selectedVenueCard = card;
      state.selectedVenue = venue;
      if (bookingRoot) {
        bookingRoot.__wbWizardVenueChosen = true;
        bookingRoot.__wbSelectedVenue = venue;
      }
      if (
        venue &&
        venue._coral_hub &&
        venue.sell_product_handle &&
        !venue._sellVariantsLoaded &&
        window.WorkshopBookingCoralHub &&
        typeof window.WorkshopBookingCoralHub.prefetchSellVariants === 'function'
      ) {
        window.WorkshopBookingCoralHub.prefetchSellVariants(venue);
      }
      state.venueDisplayLabel = resolveVenueDisplayLabel(venue, card);
      state.flow = venueIsWaitlistOnly(venue, card) ? 'waitlist' : 'booking';
      wizardRoot.setAttribute('data-wbw-flow', state.flow);
      syncVenueKindAttr();
      if (!(options && options.skipAnalytics)) {
        try {
          var wbwA = global.WorkshopBookingWizardAnalytics;
          if (wbwA && typeof wbwA.trackUser === 'function') {
            wbwA.trackUser('venue', 'wbw_venue_select', state, wizardRoot, S.data || {}, {
              wbw_source: 'venue_card',
            });
          } else if (wbwA && typeof wbwA.track === 'function') {
            if (typeof wbwA.mark === 'function') wbwA.mark('venue');
            wbwA.track('wbw_venue_select', state, wizardRoot, S.data || {}, {
              wbw_source: 'venue_card',
            });
          }
        } catch (_) {}
      }
      wbwEmitVenueMapSelection(venue);
      syncVenueFlipState();
      /* Do not write ?venue= on Step 1 select — only when entering datetime. */
      updateVenueContinue();
      updateProgressLabels();
      updateBranchTitles();
      syncSiblingWorkshopPromo();
      if (options && options.updatePageCopy) updateProductVenueSeoCopy();
      prefetchVenueCalendar(venue);
    }

    function bindVenueSelection() {
      if (!eventsRoot) return;
      eventsRoot.addEventListener('click', function (e) {
        if (e.target.closest('[data-wbw-wl-signup]')) {
          e.preventDefault();
          e.stopPropagation();
          var wlCard = e.target.closest('.wb-venue-pick-card, .wb-venue-card');
          if (wlCard && wlCard._wbVenue) selectVenueCard(wlCard, { updatePageCopy: true });
          openWizardWaitlistModal();
          return;
        }
        if (e.target.closest('[data-wb-waitlist-open]')) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }
        var card = e.target.closest('.wb-venue-pick-card, .wb-venue-card');
        if (!card || !wizardRoot.contains(card)) return;
        if (!card._wbVenue) return;
        e.preventDefault();
        activateVenueCard(card);
      });
      eventsRoot.addEventListener('pointerover', function (e) {
        var card = e.target.closest('.wb-venue-pick-card, .wb-venue-card');
        if (!card || !wizardRoot.contains(card) || !card._wbVenue) return;
        if (card.__wbwCalPrefetched) return;
        card.__wbwCalPrefetched = true;
        prefetchVenueCalendar(card._wbVenue);
      });
      eventsRoot.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var card = e.target.closest('.wb-venue-pick-card[role="button"], .wb-venue-card[role="button"]');
        if (!card || !wizardRoot.contains(card) || !card._wbVenue) return;
        if (e.target.closest('[data-wbw-wl-signup]')) return;
        e.preventDefault();
        activateVenueCard(card);
      });
      wizardRoot.querySelectorAll('[data-wbw-wl-modal-dismiss]').forEach(function (el) {
        el.addEventListener('click', function (e) {
          e.preventDefault();
          closeWizardWaitlistModal();
        });
      });
      document.addEventListener('wbw:open-waitlist-modal', function (e) {
        var d = (e && e.detail) || {};
        if (d.bookingRoot && bookingRoot && d.bookingRoot !== bookingRoot) return;
        openWizardWaitlistModalFromDetail(d);
      });
      document.addEventListener('wbw:venue-list-rendered', function () {
        window.setTimeout(maybeOpenWaitlistPopupFromUrl, 0);
      });
      window.setTimeout(maybeOpenWaitlistPopupFromUrl, 0);
    }

    function getVenueTokenFromUrl() {
      var H = global.WorkshopBookingWizardHelpers;
      if (H && typeof H.getVenueTokenFromUrl === 'function') return H.getVenueTokenFromUrl();
      try {
        return (new URLSearchParams(window.location.search).get('venue') || '').trim();
      } catch (_) {
        return '';
      }
    }

    /** After URL deep-link selects a waitlist venue, open the same popup as Sign up for Waitlist. */
    function maybeOpenWaitlistPopupFromUrl() {
      if (wizardRoot.__wbwWaitlistDeepLinkOpened) return;
      if (wizardRoot.__wbwUserReachedDatetime) return;
      if (state.branch === 'datetime' || state.branch === 'variants') return;
      if (!getVenueTokenFromUrl() && !urlHasWizardDeepLink()) return;
      if (state.flow !== 'waitlist' || !state.selectedVenue) return;
      wizardRoot.__wbwWaitlistDeepLinkOpened = true;
      handleWaitlistDeepLink(state.selectedVenueCard);
    }

    function startWaitlistStep() {
      var step = stepEl('waitlist');
      if (!step) return;
      updateBranchTitles();
      var err = step.querySelector('[data-wbw-wl-error]');
      var ok = step.querySelector('[data-wbw-wl-success]');
      if (err) err.hidden = true;
      if (ok) ok.hidden = true;
      setBranch('waitlist');
    }

    function goToNextFromVenue() {
      rebindSelectedVenueCard();
      if (!state.selectedVenue || !String(state.selectedVenue.venue_ref_id || '').trim()) {
        clearVenueSelection();
        return;
      }
      if (state.flow === 'waitlist' || state.selectedVenue.has_events !== true) return;
      var start = isStoreVenue(state.selectedVenue) ? startDatetimeStep : startPopupBookingStep;
      return Promise.resolve()
        .then(function () {
          return start();
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          try {
            console.warn('[wbw] continue from venue failed', err);
          } catch (_) {}
          var msg =
            err && err.message
              ? String(err.message).slice(0, 120)
              : "Couldn't continue booking. Try again.";
          if (isStoreVenue(state.selectedVenue)) {
            setDatetimeCalLoading(true, "Couldn't load dates. Try again.");
          } else {
            setPopupDatetimeLoading(false);
            setPopupDatetimeHint(msg, true);
          }
        });
    }

    function activateVenueCard(card) {
      if (!card || !card._wbVenue) return;
      selectVenueCard(card, { updatePageCopy: true });
      var venue = card._wbVenue;
      try {
        if (window.WBSessionTrace) {
          window.WBSessionTrace.push({
            type: 'venue_tap',
            detail: {
              venue_ref_id: String((venue && (venue.venue_ref_id || venue.venue_id)) || ''),
              has_events: venue && venue.has_events === true ? 1 : 0,
            },
          });
        }
      } catch (_) {}
      /** Coral hub: availability already stamped via events-batch enrich. */
      if (venue._coral_hub || (bookingRoot && bookingRoot.__wbCoralHub)) {
        if (venue.has_events === true && venue._wbWaitlistVenue !== true) {
          card.removeAttribute('data-wb-waitlist-venue');
          state.flow = 'booking';
          wizardRoot.setAttribute('data-wbw-flow', 'booking');
          return goToNextFromVenue();
        }
        // No sessions → normal waitlist path below (probe still allowed).
      }

      var looksWaitlist =
        card.getAttribute('data-wb-waitlist-venue') === '1' ||
        venue._wbWaitlistVenue === true ||
        venue.has_events !== true;

      if (!looksWaitlist) {
        return goToNextFromVenue();
      }

      /*
       * Discovery can mark a venue waitlist while bookable sessions exist for this
       * product (admin shows Bookable). Probe venue calendar before locking waitlist UI.
       */
      if (!bookingRoot || typeof bookingRoot.__wbEnsureVenueCalendar !== 'function') {
        return;
      }
      if (card.__wbwWaitlistProbeInFlight) return card.__wbwWaitlistProbeInFlight;
      var view = new Date();
      if (venue.next_date_key && /^\d{4}-\d{2}/.test(String(venue.next_date_key))) {
        var nd = String(venue.next_date_key);
        view = new Date(Number(nd.slice(0, 4)), Number(nd.slice(5, 7)) - 1, 1);
      }
      card.classList.add('is-probing-sessions');
      card.__wbwWaitlistProbeInFlight = bookingRoot
        .__wbEnsureVenueCalendar(venue, view, {
          lookahead: 1,
          prefetch: false,
          abortPrevious: true
        })
        .then(function () {
          card.classList.remove('is-probing-sessions');
          card.__wbwWaitlistProbeInFlight = null;
          var evs = Array.isArray(venue.events) ? venue.events : [];
          if (!evs.length) return;
          venue.has_events = true;
          try {
            delete venue._wbWaitlistVenue;
          } catch (_) {
            venue._wbWaitlistVenue = false;
          }
          card.removeAttribute('data-wb-waitlist-venue');
          card._wbVenue = venue;
          state.selectedVenue = venue;
          state.flow = 'booking';
          wizardRoot.setAttribute('data-wbw-flow', 'booking');
          syncVenueFlipState();
          updateVenueContinue();
          return goToNextFromVenue();
        })
        .catch(function () {
          card.classList.remove('is-probing-sessions');
          card.__wbwWaitlistProbeInFlight = null;
          try {
            if (window.WBSessionTrace) {
              window.WBSessionTrace.push({
                type: 'calendar_probe_fail',
                detail: {
                  venue_ref_id: String((venue && (venue.venue_ref_id || venue.venue_id)) || ''),
                },
              });
              window.WBSessionTrace.flush('calendar_probe_fail');
            }
          } catch (_) {}
        });
      return card.__wbwWaitlistProbeInFlight;
    }

    /** Deep-link (?venue=…): open Connect/native waitlist popup, or advance if sessions exist. */
    function handleWaitlistDeepLink(card) {
      var venue = state.selectedVenue;
      if (!venue) return Promise.resolve();
      wizardRoot.__wbwUrlDeepLinkComplete = true;

      function openPopup() {
        openWizardWaitlistModal();
      }

      if (!bookingRoot || typeof bookingRoot.__wbEnsureVenueCalendar !== 'function') {
        openPopup();
        return Promise.resolve();
      }

      var view = new Date();
      if (venue.next_date_key && /^\d{4}-\d{2}/.test(String(venue.next_date_key))) {
        var nd = String(venue.next_date_key);
        view = new Date(Number(nd.slice(0, 4)), Number(nd.slice(5, 7)) - 1, 1);
      }

      return bookingRoot
        .__wbEnsureVenueCalendar(venue, view, {
          lookahead: 1,
          prefetch: false,
          abortPrevious: true,
        })
        .then(function () {
          var evs = Array.isArray(venue.events) ? venue.events : [];
          if (evs.length) {
            venue.has_events = true;
            try {
              delete venue._wbWaitlistVenue;
            } catch (_) {
              venue._wbWaitlistVenue = false;
            }
            if (card) {
              card.removeAttribute('data-wb-waitlist-venue');
              card._wbVenue = venue;
            }
            state.selectedVenue = venue;
            state.flow = 'booking';
            wizardRoot.setAttribute('data-wbw-flow', 'booking');
            syncVenueFlipState();
            updateVenueContinue();
            return goToNextFromVenue();
          }
          openPopup();
        })
        .catch(function () {
          openPopup();
        });
    }

      S.findVenueCardByRef = findVenueCardByRef;
      S.rebindSelectedVenueCard = rebindSelectedVenueCard;
      S.updateVenueContinue = updateVenueContinue;
      S.syncVenueFlipState = syncVenueFlipState;
      S.closeWizardWaitlistModal = closeWizardWaitlistModal;
      S.openWizardWaitlistModal = openWizardWaitlistModal;
      S.wbwEmitVenueMapSelection = wbwEmitVenueMapSelection;
      S.wbwSyncVenueMapSelection = function () {
        if (state.selectedVenue) wbwEmitVenueMapSelection(state.selectedVenue);
      };
      S.venueSessionKey = venueSessionKey;
      S.clonePlainMap = clonePlainMap;
      S.peekVenueSession = peekVenueSession;
      S.stashVenueSession = stashVenueSession;
      S.applySavedVenueSession = applySavedVenueSession;
      S.clearVenueSelection = clearVenueSelection;
      S.onVenueResetEvent = onVenueResetEvent;
      S.selectVenueCard = selectVenueCard;
      S.bindVenueSelection = bindVenueSelection;
      S.startWaitlistStep = startWaitlistStep;
      S.goToNextFromVenue = goToNextFromVenue;
      S.activateVenueCard = activateVenueCard;
      S.handleWaitlistDeepLink = handleWaitlistDeepLink;
    }
  };
})(typeof window !== "undefined" ? window : this);
